<div class="container py-3 PGCreateBooking">
    @if (isLoading || isSavingDraft) {
        <app-pg-loading [isLarge]="true" [isOverlay]="isSavingDraft"></app-pg-loading>
    }
    @if (!isLoading) {
        @if (cumulativeProductId != null) {
            <h1>{{ 'pg-create-booking.title-cumulative' | locTranslate }}</h1>
            
            <app-pg-booking-product compact="never" [productData]="productData" [selectedLanguage]="state.selectedLanguage"
                [selectedAvailability]="state.selectedAvailability" [selectedAccommodation]="state.selectedAccommodation" [selectedTickets]="state.selectedTickets" [surveyAnswers]="state.surveyAnswers"
                [userName]="editUserContact.name"
                [userEmail]="(editUserContact.via == 'email' ? editUserContact.value : null)"
                [userPhone]="(editUserContact.via == 'phone' ? editUserContact.value : editUserContact.phone)"
            [paymentMethod]="state.selectedPaymentMethod"></app-pg-booking-product>

            @if (!productData.bookable) {
                <div class="alert alert-warning my-3">
                    <h4 class="mb-3">
                        <i class="fa-regular fa-exclamation-triangle me-3"></i>
                        <span>{{ 'pg-create-booking.not-bookable-title' | locTranslate }}</span>
                    </h4>
                    <p class="mb-3">
                        {{ 'pg-create-booking.not-bookable-text' | locTranslate }}
                    </p>
                </div>
            }
            @else {
                @if (lastStep != null) {
                    <div>
                        <button class="btn btn-sm btn-link p-0 mt-2" (click)="goPrevStep()">
                            <span>{{ 'pg-create-booking.button-edit-' + getLastStepTranslationId() | locTranslate }}</span>
                        </button>
                    </div>
                }
                
                @if (currentStep == 'language') {
                    <div class="col-12 mt-3">
                        <label class="mb-1"><b>{{ 'pg-create-booking.' + productType + '-language' | locTranslate }}</b></label>
                        <select class="form-control" [(ngModel)]="state.selectedLanguage" (ngModelChange)="goNextStep()">
                            @for (language of languageOptions; track language) {
                                <option [value]="language.value">{{ language.text }}</option>
                            }
                        </select>
                    </div>
                }

                @if (currentStep == 'availability') {
                    <div class="col-12">
                        @if (productType != 'host') {
                            <h3 class="mt-3">{{ 'pg-create-booking.choose-date' | locTranslate }}</h3>
                        }
                        @if (productType == 'host') {
                            <h3 class="mt-3">{{ 'pg-create-booking.choose-date-host' | locTranslate }}</h3>
                        }
                        <app-pg-availability-select [productType]="productType" [productId]="'cumulative'" [productAvailability]="availabilityData" [productCapacity]="null" [bookingDeadline]="null" (availabilitySelected)="onAvailabilitySelected($event)"  [dayMode]="getAvailabilityDayMode()"></app-pg-availability-select>
                    </div>
                }
            
                @if (currentStep == 'tickets') {
                    <div class="col-12">
                        <h3 class="mt-3">{{ 'pg-create-booking.choose-tickets-cumulative' | locTranslate }}</h3>
                        <app-pg-tickets-select [priceOnRequest]="true" [ticketsData]="ticketsData" [availabilitySelected]="state.selectedAvailability" [currency]="getCurrency()" (ticketsSelected)="onTicketsSelected($event)" [single]="productType == 'host'"></app-pg-tickets-select>
                    </div>
                }

                @if (currentStep == 'survey') {
                    <div class="col-12">
                        <h3 class="mt-3">{{ 'pg-create-booking.survey' | locTranslate }}</h3>
                        <app-pg-survey-answers [surveyData]="surveyData" (surveyAnswered)="onSurveyAnswered($event)"></app-pg-survey-answers>
                    </div>
                }

                @if (currentStep == 'payment-method') {
                    <div class="col-12">
                        <div class="mt-3">
                            <label class="mb-1"><b>{{ 'pg-create-booking.input-contact-name' | locTranslate }}</b></label>
                            <input type="text" class="form-control" [(ngModel)]="editUserContact.name"/>
                            @if (editUserContact.name == null || editUserContact.name == '') {
                                <small class="form-text text-danger">{{ 'pg-create-booking.invalid-contact-name' | locTranslate }}</small>
                            }
                        </div>
                        <div class="mt-3">
                            <label class="mb-1"><b>{{ 'pg-create-booking.input-contact-email' | locTranslate }}</b></label>
                            <app-pg-email [(ngModel)]="editUserContact.value"></app-pg-email>
                            @if (!isEditUserContactEmailValid()) {
                                <small class="form-text text-danger">{{ 'pg-create-booking.invalid-contact-email' | locTranslate }}</small>
                            }
                        </div>
                        <div class="mt-3">
                            <label class="mb-1"><b>{{ 'pg-create-booking.input-contact-phone' | locTranslate }}</b></label>
                            <app-pg-phone [(ngModel)]="editUserContact.phone"></app-pg-phone>
                            <small class="form-text">{{ 'pg-create-booking.phone-default-prefix' | locTranslate }}</small>
                            @if (!isEditUserContactPhoneValid()) {
                                <small class="form-text text-danger d-block">{{ 'pg-create-booking.invalid-contact-phone' | locTranslate }}</small>
                            }
                        </div>
                        <button [disabled]="!isEditUserContactEmailValid() || !isEditUserContactPhoneValid()" class="btn btn-primary btn-block mb-1 mt-3" (click)="onPaymentMethodSelected(null)">
                            <span>{{ 'pg-create-booking.button-next' | locTranslate }}</span>
                        </button>
                    </div>
                }

                @if (currentStep == 'confirm') {
                    <div class="col-12 mt-3">
                        <label class="mb-1"><b>{{ 'pg-create-booking.additional-informations' | locTranslate }}</b></label>
                        <textarea class="form-control" [(ngModel)]="state.additionalInformations" placeholder="{{ 'pg-create-booking.additional-informations-placeholder' | locTranslate }}"></textarea>
                    </div>
                    <div class="col-12">
                        <button class="btn btn-primary btn-lg btn-block mt-3" [disabled]="!canConfirmBooking()" (click)="confirmBooking()">{{ 'pg-create-booking.button-confirm' | locTranslate }}</button>
                    </div>
                }
            }
        }
        @else {
            @if (productData == null || supplierData == null) {
                <div class="alert alert-danger">
                    <h4 class="mb-3">
                        <i class="fa-regular fa-exclamation-triangle me-3"></i>
                        <span>{{ 'pg-create-booking.not-found-title' | locTranslate }}</span>
                    </h4>
                    <p class="mb-0">
                        @if (productData == null) {
                            {{ 'pg-create-booking.product-not-found-text' | locTranslate }}
                        }
                        @if (productData != null && supplierData == null) {
                            {{ 'pg-create-booking.supplier-not-found-text' | locTranslate }}
                        }
                    </p>
                </div>
            }
            @else {
                <h1>{{ 'pg-create-booking.title-' + productType | locTranslate }}</h1>
                @if (warnNoLongerAvailable) {
                    <div class="alert alert-warning">
                        <h4 class="mb-3">
                            <i class="fa-regular fa-exclamation-triangle me-3"></i>
                            <span>{{ 'pg-create-booking.no-longer-available-title' | locTranslate }}</span>
                        </h4>
                        <p class="mb-0">
                            {{ 'pg-create-booking.no-longer-available-text' | locTranslate }}
                        </p>
                    </div>
                }
                @if (warnBookingClosed) {
                    <div class="alert alert-warning">
                        <h4 class="mb-3">
                            <i class="fa-regular fa-exclamation-triangle me-3"></i>
                            <span>{{ 'pg-create-booking.booking-closed-title' | locTranslate }}</span>
                        </h4>
                        <p class="mb-0">
                            {{ 'pg-create-booking.booking-closed-text' | locTranslate }}
                        </p>
                    </div>
                }
                <app-pg-booking-product compact="never" [productData]="productData" [selectedLanguage]="state.selectedLanguage"
                    [selectedAvailability]="state.selectedAvailability" [selectedAccommodation]="state.selectedAccommodation" [selectedTickets]="state.selectedTickets" [surveyAnswers]="state.surveyAnswers"
                    [userName]="state.selectedPaymentMethod == null ? null : editUserContact.name"
                    [userEmail]="state.selectedPaymentMethod == null ? null : (editUserContact.via == 'email' ? editUserContact.value : null)"
                    [userPhone]="state.selectedPaymentMethod == null ? null : (editUserContact.via == 'phone' ? editUserContact.value : editUserContact.phone)"
                    [brokerCode]="state.selectedPaymentMethod != null && editBrokerCode.enabled && editBrokerCode.status == 'valid' ? editBrokerCode.value : null"
                    [discountCode]="state.selectedPaymentMethod != null && editVoucherCode.enabled && editVoucherCode.status == 'valid' ? editVoucherCode.result.code : null"
                    [discountValue]="state.selectedPaymentMethod != null && editVoucherCode.enabled && editVoucherCode.status == 'valid' ? editVoucherCode.result.discount : null"
                [paymentMethod]="state.selectedPaymentMethod"></app-pg-booking-product>
                @if (!isPayable()) {
                    <div class="alert alert-warning my-3">
                        <h4 class="mb-3">
                            <i class="fa-regular fa-exclamation-triangle me-3"></i>
                            <span>{{ 'pg-create-booking.no-payment-method-title' | locTranslate }}</span>
                        </h4>
                        <p class="mb-3">
                            {{ 'pg-create-booking.no-payment-method-text' | locTranslate }}
                        </p>
                        <div>
                            @for (experience of onlinePaymentOnlyExperiences; track experience) {
                                <div>
                                    <a routerLink="/edit/experience/{{experience.id}}">{{ experience.id }} - {{ experience.title }}</a>
                                </div>
                            }
                        </div>
                    </div>
                }
                @if (!productData.bookable) {
                    <div class="alert alert-warning my-3">
                        <h4 class="mb-3">
                            <i class="fa-regular fa-exclamation-triangle me-3"></i>
                            <span>{{ 'pg-create-booking.not-bookable-title' | locTranslate }}</span>
                        </h4>
                        <p class="mb-3">
                            {{ 'pg-create-booking.not-bookable-text' | locTranslate }}
                        </p>
                    </div>
                }

                @if (productData.bookable && productType == 'host' && accommodationData.length == 0) {
                    <div class="alert alert-warning my-3">
                        <h4 class="mb-3">
                            <i class="fa-regular fa-exclamation-triangle me-3"></i>
                            <span>{{ 'pg-create-booking.no-valid-accommodation-title' | locTranslate }}</span>
                        </h4>
                        <p class="mb-3">
                            {{ 'pg-create-booking.no-valid-accommodation-text' | locTranslate }}
                        </p>
                    </div>
                }

                @if (productData.bookable && isPayable() && (productType != 'host' || accommodationData.length > 0)) {
                    @if (lastStep != null) {
                        <div>
                            <button class="btn btn-sm btn-link p-0 mt-2" (click)="goPrevStep()">
                                <span>{{ 'pg-create-booking.button-edit-' + getLastStepTranslationId() | locTranslate }}</span>
                            </button>
                        </div>
                    }
                    <div class="row">
                        @if (currentStep == 'language') {
                            <div class="col-12 mt-3">
                                <label class="mb-1"><b>{{ 'pg-create-booking.' + productType + '-language' | locTranslate }}</b></label>
                                <select class="form-control" [(ngModel)]="state.selectedLanguage" (ngModelChange)="goNextStep()">
                                    @for (language of languageOptions; track language) {
                                        <option [value]="language.value">{{ language.text }}</option>
                                    }
                                </select>
                            </div>
                        }
                        @if (currentStep == 'availability') {
                            <div class="col-12">
                                @if (productType != 'host') {
                                    <h3 class="mt-3">{{ 'pg-create-booking.choose-date' | locTranslate }}</h3>
                                }
                                @if (productType == 'host') {
                                    <h3 class="mt-3">{{ 'pg-create-booking.choose-date-host' | locTranslate }}</h3>
                                }
                                <app-pg-availability-select [productType]="productType" [productId]="productId" [productAvailability]="availabilityData" [productCapacity]="!hasParticipantsLimit() ? null : productData.maximum_participants" [bookingDeadline]="productData.booking_deadline" (availabilitySelected)="onAvailabilitySelected($event)"  [dayMode]="getAvailabilityDayMode()"></app-pg-availability-select>
                            </div>
                        }
                        @if (currentStep == 'accommodation') {
                            <div class="col-12">
                                <h3 class="mt-3">{{ 'pg-create-booking.choose-accommodation' | locTranslate }}</h3>
                                @for (accommodation of accommodationData; track accommodation) {
                                    <div>
                                        <button class="btn btn-block border mb-2 py-2 text-start PGCreateBooking-AccommodationButton" (click)="setSelectedAccommodation(accommodation)">
                                            <div class="PGCreateBooking-AccommodationButton-Background bg-primary"></div>
                                            <app-pg-product-host-accommodation [accommodationData]="accommodation"></app-pg-product-host-accommodation>
                                        </button>
                                    </div>
                                }
                            </div>
                        }
                        @if (currentStep == 'tickets') {
                            <div class="col-12">
                                <h3 class="mt-3">{{ 'pg-create-booking.choose-tickets' + (productType == 'host' ? '-host' : '') | locTranslate }}</h3>
                                <app-pg-tickets-select [priceOnRequest]="priceOnRequest" [ticketsData]="ticketsData" [availabilitySelected]="state.selectedAvailability" [currency]="getCurrency()" (ticketsSelected)="onTicketsSelected($event)" [single]="productType == 'host'"></app-pg-tickets-select>
                            </div>
                        }
                        @if (currentStep == 'survey') {
                            <div class="col-12">
                                <h3 class="mt-3">{{ 'pg-create-booking.survey' | locTranslate }}</h3>
                                <app-pg-survey-answers [surveyData]="surveyData" (surveyAnswered)="onSurveyAnswered($event)"></app-pg-survey-answers>
                            </div>
                        }
                        @if (currentStep == 'payment-method') {
                            <div class="col-12">
                                <div class="mt-3">
                                    <label class="mb-1"><b>{{ 'pg-create-booking.input-contact-name' | locTranslate }}</b></label>
                                    <input type="text" class="form-control" [(ngModel)]="editUserContact.name"/>
                                    @if (editUserContact.name == null || editUserContact.name == '') {
                                        <small class="form-text text-danger">{{ 'pg-create-booking.invalid-contact-name' | locTranslate }}</small>
                                    }
                                </div>
                                <div class="mt-3">
                                    <label class="mb-1"><b>{{ 'pg-create-booking.input-contact' + (productData.mandatory_email ? '-email' : '') | locTranslate }}</b></label>
                                    <app-pg-recipient [disablePhone]="productData.mandatory_email" [(ngModel)]="editUserContact.value" (viaChange)="editUserContact.via = $event;"></app-pg-recipient>
                                    @if (editUserContact.via == 'phone') {
                                        <small class="form-text">{{ 'pg-create-booking.phone-default-prefix' | locTranslate }}</small>
                                    }
                                    @if (editUserContact.via == null) {
                                        <small class="form-text text-danger">{{ 'pg-create-booking.invalid-'  + (productData.mandatory_email ? 'contact-email' : 'contact') | locTranslate }}</small>
                                    }
                                </div>
                                @if (productData.mandatory_email || editUserContact.via == 'email') {
                                    <div class="mt-3">
                                        <label class="mb-1"><b>{{ 'pg-create-booking.input-contact-phone' | locTranslate }}</b></label>
                                        <app-pg-phone [(ngModel)]="editUserContact.phone"></app-pg-phone>
                                        <small class="form-text">{{ 'pg-create-booking.phone-default-prefix' | locTranslate }}</small>
                                        @if (!isEditUserContactPhoneValid()) {
                                            <small class="form-text text-danger d-block">{{ 'pg-create-booking.invalid-contact-phone' | locTranslate }}</small>
                                        }
                                    </div>
                                }
                                @if (isBookingFree()) {
                                    <button [disabled]="editUserContact.via == null" class="btn btn-primary btn-block mb-1 mt-3" (click)="onPaymentMethodSelected('gratis')">
                                        <i class="fa-regular fa-gift"></i>
                                        <span>{{'OPTIONMAPS.' + getCapitalizedProductType() + '.payment.gratis' | locTranslate}}</span>
                                    </button>
                                }
                                @else {
                                    <h3 class="mt-3">{{ 'pg-create-booking.choose-payment-method' | locTranslate }}</h3>
                                    @if (hasTickets()) {
                                        @if (hasVoucher()) {
                                            <div class="d-flex mb-3">
                                                <app-pg-switch [small]="true" [ngModel]="editVoucherCode.enabled" (ngModelChange)="setVoucherCodeEnabled($event)"></app-pg-switch>
                                                <div class="ms-2">{{ 'pg-create-booking.input-discount' | locTranslate }}</div>
                                            </div>
                                            @if (editVoucherCode.enabled) {
                                                <div class="mb-3">
                                                    <label class="mb-1"><b>{{ 'pg-create-booking.input-discount-code' | locTranslate }}</b></label>
                                                    <app-pg-code-checker [(value)]="editVoucherCode.value" [codeCheck]="checkVoucherCode" (statusChange)="editVoucherCode.status = $event" (resultChange)="editVoucherCode.result = $event" (errorChange)="editVoucherCode.error = $event"></app-pg-code-checker>
                                                    @if (editVoucherCode.status == 'invalid') {
                                                        <div class="form-text text-danger mb-3">
                                                            {{ 'pg-create-booking.invalid-discount-code' + (editVoucherCode.error != null ? '-' + editVoucherCode.error : '') | locTranslate }}
                                                        </div>
                                                    }
                                                    @if (editVoucherCode.status == 'valid') {
                                                        <div class="mb-3">
                                                            <div class="form-text text-success mb-3">{{ 'pg-create-booking.valid-discount-code' | locTranslate }}</div>
                                                            <div>
                                                                <span>{{ 'pg-create-booking.discount-value' | locTranslate }}</span>
                                                                <b class="float-end">{{editVoucherCode.result.discount}} %</b>
                                                            </div>
                                                            <div>
                                                                <span>{{ 'pg-create-booking.discount-price' | locTranslate }}</span>
                                                                <b class="float-end">{{getDiscountPrice(editVoucherCode.result.discount)}} {{getCurrencySymbol()}}</b>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            }
                                        }
                                        @if (hasBroker()) {
                                            <div class="d-flex mb-3">
                                                <app-pg-switch [small]="true" [ngModel]="editBrokerCode.enabled" (ngModelChange)="setBrokerCodeEnabled($event)"></app-pg-switch>
                                                <div class="ms-2">{{ 'pg-create-booking.input-broker' | locTranslate }}</div>
                                            </div>
                                            @if (editBrokerCode.enabled) {
                                                <div>
                                                    <div class="form-text mb-3" [innerHTML]="'pg-create-booking.input-broker-code-text' | locTranslate:'url':brokerRegisterURL"></div>
                                                    <label class="mb-1"><b>{{ 'pg-create-booking.input-broker-code' | locTranslate }}</b></label>
                                                    <app-pg-code-checker [(value)]="editBrokerCode.value" [codeCheck]="checkBrokerCode" (statusChange)="editBrokerCode.status = $event" (resultChange)="editBrokerCode.result = $event"></app-pg-code-checker>
                                                    <div class="d-flex my-2">
                                                        <app-pg-switch [small]="true" [(ngModel)]="localStorageEnabled" (ngModelChange)="onLocalStorageEnabledChange()"></app-pg-switch>
                                                        <div class="ms-2">{{ 'pg-create-booking.input-broker-remember-code' | locTranslate }}</div>
                                                    </div>
                                                    @if (editBrokerCode.status == 'invalid') {
                                                        <div class="form-text text-danger mb-3">{{ 'pg-create-booking.invalid-broker-code' | locTranslate }}</div>
                                                    }
                                                    @if (editBrokerCode.status == 'valid') {
                                                        <div class="mb-3">
                                                            <div class="form-text text-success mb-3">{{ 'pg-create-booking.valid-broker-code' | locTranslate:'name':editBrokerCode.result.name }}</div>
                                                            <div>
                                                                <span>{{ 'pg-create-booking.broker-discount' | locTranslate }}</span>
                                                                <b class="float-end">{{productData.broker_discount}} %</b>
                                                            </div>
                                                            <div>
                                                                <span>{{ 'pg-create-booking.broker-quota' | locTranslate }}</span>
                                                                <b class="float-end">{{getBrokerQuota()}} {{getCurrencySymbol()}}</b>
                                                            </div>
                                                        </div>
                                                    }
                                                    <button [disabled]="!isEditUserContactValid() || editBrokerCode.status != 'valid'" class="btn btn-primary btn-block mb-1" (click)="onPaymentMethodSelected('broker')">
                                                        <span>{{ 'pg-create-booking.broker-confirm' | locTranslate}}</span>
                                                    </button>
                                                </div>
                                            }
                                        }
                                    }
                                    @if (!hasBroker() || !editBrokerCode.enabled) {
                                        @if (priceOnRequest) {
                                            <button  [disabled]="!isEditUserContactValid()" class="btn btn-primary btn-block mb-1" (click)="onPaymentMethodSelected('price_on_request')">
                                                <i class="fa-regular fa-phone"></i>
                                                <span>{{'pg-create-booking.payment-price_on_request' | locTranslate}}</span>
                                            </button>
                                        }
                                        @if (!priceOnRequest) {
                                            @for (paymentMethod of paymentMethodOptions; track paymentMethod) {
                                                <button [disabled]="!isEditUserContactValid()" class="btn btn-primary btn-block mb-1" (click)="onPaymentMethodSelected(paymentMethod.value)">
                                                    <i class="{{paymentMethod.icon}}"></i>
                                                    <span>{{paymentMethod.text | locTranslate}}</span>
                                                </button>
                                            }
                                        }
                                    }
                                }
                            </div>
                        }
                        @if (currentStep == 'confirm') {
                            <div class="col-12 mt-3">
                                <label class="mb-1"><b>{{ 'pg-create-booking.additional-informations' | locTranslate }}</b></label>
                                <textarea class="form-control" [(ngModel)]="state.additionalInformations" placeholder="{{ 'pg-create-booking.additional-informations-placeholder' | locTranslate }}"></textarea>
                            </div>
                            <div class="col-12">
                                <button class="btn btn-primary btn-lg btn-block mt-3" [disabled]="!canConfirmBooking()" (click)="confirmBooking()">{{ 'pg-create-booking.button-confirm' | locTranslate }}</button>
                            </div>
                        }
                    </div>
                }
            }
        }
    }
</div>

@if (mustLoginToProceed && !isLoggedIn()) {
    <app-pg-login-handler customMessage="{{ 'pg-create-booking.login-message' | locTranslate:'disableSMS':disableSMS }}" otpMode="true" codeMode="true"></app-pg-login-handler>
}